export default "__VITE_ASSET__BsXqu$2x__"